<template>
  <div>
    <v-app-bar
      class="header-mobile"
      scroll-threshold="100"
      elevate-on-scroll
      hide-on-scroll
      color="white"
      height="96px"
      app
    >
      <v-sheet
        class="
          d-flex
          flex-column flex-sm-row
          justify-center
          align-center
          justify-sm-space-between
        "
        color="transparent"
        width="100%"
      >
        <router-link to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            height="46px"
            class="d-block"
          />
        </router-link>

        <div class="d-flex">
          <template v-for="(item, keySocial) in social">
            <v-btn
              v-if="item"
              :key="keySocial"
              :href="item.link"
              target="blank"
              class="mr-l d-flex"
              width="40px"
              height="40px"
              icon
            >
              <v-icon color="grey darken-2" size="20">
                {{ item.icon }}
              </v-icon>
            </v-btn>
          </template>
        </div>
      </v-sheet>
    </v-app-bar>
  </div>
</template>

<script>
import { getSocial } from "../../../utils/getSocial";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      current: this.$route.path,
      drawer: false,
    };
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return getSocial(this.informations);
    },
  },
};
</script>

<style lang="scss" scoped>
.header-mobile-navigation {
  .navbar-brand {
    width: 90%;
  }
}

.dropdown-menu::v-deep {
  .v-icon {
    font-size: 14px !important;
    color: white !important;
  }

  .v-list-group__header {
    margin-bottom: 0 !important;
    margin-top: 8px;
  }

  .v-list-group__items {
    background-color: rgba(0, 0, 0, 0.1);
  }
}
</style>
